export default __webpack_public_path__ + "static/media/discounts-step-up-image.8e0e5d38.svg";